import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface ProjectListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class ProjectListPage extends Component<ProjectListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.project(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}